(() => {
  const data = document.currentScript?.dataset || {};
  const parseJson = (value, fallback = null) => {
    if (!value) return fallback;
    try { return JSON.parse(value); } catch (_error) { return fallback; }
  };

  window.afterpay_logo_theme = 'black';

  if (data.productSelector) {
    window.afterpay_product_selector = data.productSelector;
  }

  window.afterpay_js_language = parseJson(data.language, 'en');
  window.afterpay_js_country = parseJson(data.country, 'US');
  window.afterpay_shop_currency = parseJson(data.shopCurrency, 'USD');
  window.afterpay_cart_currency = parseJson(data.cartCurrency, window.afterpay_shop_currency);
  window.afterpay_shop_money_format = parseJson(data.shopMoneyFormat, '${{amount}}');
  window.afterpay_shop_permanent_domain = parseJson(data.shopPermanentDomain, '');
  window.afterpay_theme_name = parseJson(data.themeName, '');
  window.afterpay_product = parseJson(data.product, null);
  window.afterpay_product_collections = parseJson(data.productCollections, '');
  window.afterpay_current_variant = parseJson(data.currentVariant, null);
  window.afterpay_cart_total_price = parseJson(data.cartTotalPrice, 0);
  window.afterpay_cart_skus = parseJson(data.cartSkus, '');
  window.afterpay_cart_collections = parseJson(data.cartCollections, '');
  window.afterpay_js_snippet_version = '1.2.1';
})();
